import { Injectable } from '@angular/core';
import { PermissionsService } from 'src/app/service/auth/permissions.service';

@Injectable({
  providedIn: 'root',
})
export class ToolPermissionsService {
  constructor(private permissionsService: PermissionsService) {}

  getAssetClass(row) {
    if (row.model) {
      return row?.model?.category?.assetClass?.name;
    }
    if (row.assignment) {
      return row?.assignment?.tool?.model?.category?.assetClass?.name;
    }
    return row?.category?.assetClass?.name;
  }

  isAllowed(row, resource1: string, action: string) {
    const assetClass = this.getAssetClass(row);
    if (!assetClass) return true;
    const allowed = this.permissionsService.allowMany([
      { resource1, action },
      { resource1: 'asset_class', resource2: assetClass, action },
    ]);
    return this.permissionsService.isAllowed(allowed);
  }
}
